import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Row } from 'reactstrap'

const StyledBlock = styled.div`
  padding: 16px 0 16px 20px;
  background: #F5F6F8;
  border-radius: 7px;
  margin-top: 25px;
  min-width: 188px;
  display: inline-block;
  margin-right: 14px;
`

const StyledBlockTitle = styled.div`
  font-family: Poppins;
  font-weight: 500;
  font-size: 14px;
  color: #242735;
  margin-left: 0.5rem;
`

const StyledBlockSubtitle = styled.div`
  font-family: Poppins;
  font-weight: 500;
  font-size: 14px;
  color: #EEB330;
  margin-left: 0.5rem;
`

const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 24px;
  margin-top: 9px;
`

interface BlockProps {
  title?: string,
  subtitle?: any,
  icon?: any,
  blockStyle?: any,
}

export const InfoBlock = (props: BlockProps) => (
  <StyledBlock style={props.blockStyle}>
    <Row>
      {props.icon
    && (
    <Col xs="1">
      <StyledIcon icon={props.icon} />
    </Col>
    )}
      <Col>
        <StyledBlockTitle>{props.title}</StyledBlockTitle>
        <StyledBlockSubtitle>{props.subtitle}</StyledBlockSubtitle>
      </Col>
    </Row>

  </StyledBlock>
)

InfoBlock.defaultProps = {
  title: '',
  subtitle: '',
  icon: '',
  blockStyle: {},
}

export default InfoBlock
